import React from "react"
import "./OverviewCard.scss"
import PropTypes from "prop-types"

const OverviewCard = props => {
  return <div className="OverviewCard">{props.children}</div>
}

OverviewCard.propTypes = {
  children: PropTypes.node,
}

export default OverviewCard
